import React from 'react'
import {Modal, Row} from 'antd'
import InServiceForm from '../../../../components/Project/Resources/InService/InServiceForm'

function InService(props) {
  const {
    visible,
    modalType,
    submitting,
    submit,
    update,
    formRef,
    onCancel,
  } = props
  return (
    <Modal
      visible={visible}
      title={'ClientBudget'}
      onCancel={onCancel}
      destroyOnClose={true}
      confirmLoading={submitting}
      onOk={modalType === 'new' ? submit : update}
      okText={modalType === 'new' ? 'Create' : 'Update'}
      width={'75%'}>
      <Row>
        <InServiceForm ref={formRef} {...props} />
      </Row>
    </Modal>
  )
}

InService.propTypes = {}
InService.defaultProps = {}

export default InService
